import { render, staticRenderFns } from "./period-info.vue?vue&type=template&id=5edb08c7&scoped=true"
import script from "./period-info.vue?vue&type=script&lang=js"
export * from "./period-info.vue?vue&type=script&lang=js"
import style0 from "./period-info.vue?vue&type=style&index=0&id=5edb08c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb08c7",
  null
  
)

export default component.exports